import { BRAND_MARK, brandMarkStrokeTransform } from './brandMarkGeometry';

export interface BrandMarkProps {
  size?: number;
  className?: string;
}

/** The AnyAPI logo mark: a price tag with a wildcard-asterisk payload. */
export const BrandMark = ({ size = 23, className }: BrandMarkProps) => {
  const { ring, stroke } = BRAND_MARK;
  return (
    <svg
      width={size}
      height={size}
      viewBox={BRAND_MARK.viewBox}
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path d={BRAND_MARK.tag} fill="var(--accent)" />
      <circle
        cx={ring.cx}
        cy={ring.cy}
        r={ring.r}
        fill="none"
        stroke="var(--accent-ink)"
        strokeWidth={ring.strokeWidth}
      />
      <g stroke="var(--accent-ink)" strokeWidth={stroke.strokeWidth} strokeLinecap="round">
        {BRAND_MARK.strokeRotations.map((degrees) => (
          <line
            key={degrees}
            x1={stroke.x1}
            y1={stroke.y1}
            x2={stroke.x2}
            y2={stroke.y2}
            transform={brandMarkStrokeTransform(degrees)}
          />
        ))}
      </g>
    </svg>
  );
};
